import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { orlandParkConfig } from "./data";

export default function OrlandParkPage() {
  return <CityPageTemplate config={orlandParkConfig} />;
}